import { OnboardingActionTypes } from './onboarding.types';

export const initialState = {
  startOnboarding: false,
  builderId: null,
  finishedOnboarding: false,
  wizard: {
    started: false,
    finished: false,
    id: null,
  },
};

const onboardingReducer = (state = initialState, action) => {
  switch (action.type) {
    case OnboardingActionTypes.ONBOARDING_REGISTER_SUCCESS: {
      const { builderId } = action.payload;
      return {
        ...state,
        startOnboarding: true,
        builderId,
      };
    }
    case OnboardingActionTypes.ONBOARDING_REGISTER_FAILURE: {
      return {
        ...state,
        startOnboarding: false,
      };
    }
    case OnboardingActionTypes.ONBOARDING_UPDATE_SUCCESS: {
      return {
        ...state,
        finishedOnboarding: true,
      };
    }
    case OnboardingActionTypes.ONBOARDING_UPDATE_FAILURE: {
      return {
        ...state,
        finishedOnboarding: false,
      };
    }
    case OnboardingActionTypes.WIZARD_REGISTER_SUCCESS: {
      return {
        ...state,
        wizard: {
          ...state.wizard,
          started: true,
        },
      };
    }
    case OnboardingActionTypes.WIZARD_REGISTER_FAILURE: {
      return {
        ...state,
        wizard: {
          ...state.wizard,
          started: false,
        },
      };
    }
    case OnboardingActionTypes.SET_WIZARD_REGISTER: {
      return {
        ...state,
        wizard: {
          ...state.wizard,
          id: action.payload.wizardId,
        },
      };
    }
    case OnboardingActionTypes.WIZARD_UPDATE_SUCCESS: {
      return {
        ...state,
        wizard: {
          ...state.wizard,
          finished: true,
          started: action.payload.preventChangeStart ? state.wizard.started : false,
        },
      };
    }
    case OnboardingActionTypes.WIZARD_UPDATE_FAILURE: {
      return {
        ...state,
        wizard: {
          ...state.wizard,
          finished: false,
        },
      };
    }
    case OnboardingActionTypes.RESET_ONBOARDING: {
      return {
        startOnboarding: false,
        finishedOnboarding: false,
        builderId: null,
        wizard: {
          started: false,
          finished: false,
          id: null,
        },
      };
    }
    default:
      return state;
  }
};

export default onboardingReducer;
